import { ENVIRONMENT, SENTRY_DSN } from '@/lib/constants';

import * as Sentry from '@sentry/react';

const VERSION = __APP_VERSION__;

const setupSentry = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: `quench-fe@${VERSION}`,
    tracesSampleRate: 1.0,
    maxBreadcrumbs: 150,
    beforeBreadcrumb: (breadcrumb) => {
      if (breadcrumb.category === 'console') {
        return null;
      }

      if (
        breadcrumb.category === 'xhr' &&
        (breadcrumb.data?.url.includes('localhost') ||
          breadcrumb.data?.url.includes('api.segment.io') ||
          breadcrumb.data?.url.includes('google.com'))
      ) {
        return null;
      }

      return breadcrumb;
    },
    // @ts-expect-error TODO: remove
    beforeSend: (event, hint): Sentry.Event | null => {
      type OriginalErrorType = {
        message: string;
        config?: {
          baseURL: string;
          url: string;
          method: string;
          headers?: {
            [key: string]: string;
          };
        };
        response?: {
          status: number;
          data?: unknown;
        };
        isAxiosError?: boolean;
      };

      // Modify or drop the event here
      const error = hint.originalException as OriginalErrorType | undefined;
      const baseURL = error?.config?.baseURL.replace(/\/+$/, '') || '';
      const path = error?.config?.url || '';

      if (error?.isAxiosError) {
        // Axios errors are not populating the `request` object
        if (!event.request?.url) {
          const request = {
            ...event.request,
            url: baseURL + path,
            method: error.config?.method,
            headers: error.config?.headers,
          };

          event.request = request;
        }

        if (error.response && error.response.data) {
          const contexts = {
            ...event.contexts,
            response: {
              ...event.contexts?.response,
              data: error.response.data,
              status_code: error.response.status,
            },
          };

          event.contexts = contexts;
        }

        event.transaction = event.request.url;

        event.fingerprint = [
          '{{ default }}',
          String(event.request.method),
          String(event.request.url),
          String(error.response?.status),
        ];
      }

      return event;
    },
  });
};

export { setupSentry };
